/* ゲーム即提案（sections/tg-game-quick-v1.liquid）
   ゲームを押すと、診断と同じ必要性能（tg-gss-main.js の buildGpuWhitelist）と
   商品選定（tg-recommendation-engine.js の completeResults）で販売中モデルを最大3台出す。 */
(function () {
  'use strict';

  var COMFORT = {
    unsure: { res: 'FHD', pri: 'balance' },
    fhd_smooth: { res: 'FHD', pri: 'fps' },
    wqhd_quality: { res: 'WQHD', pri: 'quality' },
    '4k': { res: '4K', pri: 'quality' }
  };
  var RANK_LABEL = ['いちばん手頃', '比較候補', '比較候補'];

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function yen(value) {
    return '¥' + Math.round(Number(value) || 0).toLocaleString('ja-JP');
  }

  function shortTitle(title) {
    return String(title || '').replace(/^(\s*【[^】]*】\s*)+/, '').replace(/(\s*【[^】]*】\s*)+$/, '').trim();
  }

  function catalogById() {
    var boot = document.querySelector('script[id^="gs-boot-"]');
    if (!boot) return {};
    try {
      var data = JSON.parse(boot.textContent);
      return (data.catalog || []).reduce(function (map, product) {
        map[product.id] = product;
        return map;
      }, {});
    } catch (error) {
      return {};
    }
  }

  function init(root) {
    var shared = window.TGGameQuick;
    var engine = window.TitanRecommendationEngine;
    var out = root.querySelector('[data-tgq-result]');
    if (!shared || !engine || !out) {
      root.setAttribute('data-tgq-ready', 'false');
      return;
    }
    var catalog = catalogById();
    var taxLabel = root.getAttribute('data-tax-label') || '';
    var layout = root.getAttribute('data-layout') || 'a';
    var state = { game: null, comfort: 'unsure' };
    var gameNames = shared.games.reduce(function (map, game) {
      map[game.k] = game.short || game.n;
      return map;
    }, {});

    function card(item, index) {
      var product = catalog[item.productId] || {};
      var title = shortTitle(product.title) || item.gpu;
      var image = product.image
        ? '<img class="tgq-card__img" src="' + esc(product.image) + '" alt="' + esc(title) + '" loading="lazy" width="900" height="900">'
        : '<span class="tgq-card__img tgq-card__img--empty"></span>';
      return (
        '<li class="tgq-card' + (index === 0 ? ' tgq-card--main' : '') + '">' +
        '<a class="tgq-card__link" href="' + esc(product.url) + '" data-titan-name="ゲーム即提案:' + esc(gameNames[state.game] || '') + ':' + (index + 1) + '">' +
        '<span class="tgq-card__media">' + image + '</span>' +
        '<span class="tgq-card__body">' +
        '<span class="tgq-card__rank">' + RANK_LABEL[index] + '</span>' +
        '<span class="tgq-card__gpu">' + esc(item.gpu) + '</span>' +
        '<span class="tgq-card__title">' + esc(title) + '</span>' +
        '<span class="tgq-card__price"><span class="tgq-card__num">' + yen(item.price) + '</span>' + (taxLabel ? '<span class="tgq-card__tax">' + esc(taxLabel) + '</span>' : '') + '</span>' +
        '<span class="tgq-card__cta">この構成を見る</span>' +
        '</span></a></li>'
      );
    }

    function render() {
      if (!state.game) return;
      var comfort = COMFORT[state.comfort] || COMFORT.unsure;
      var wl = shared.whitelist({
        games: [state.game],
        res: comfort.res,
        pri: comfort.pri,
        str: 'no',
        usages: ['gaming_only'],
        usageDetailValue: null,
        bud: 'unlimited',
        cond: 'new'
      });
      var items = engine.completeResults([], wl.products, wl.products);
      var name = gameNames[state.game] || '';
      var head = '<p class="tgq-result__head"><strong>' + esc(name) + '</strong>が遊べる販売中モデル（価格の安い順）</p>';
      if (!items.length) {
        out.innerHTML = head + '<p class="tgq-result__empty">この条件に合う販売中モデルが今はありません。下の診断で条件を変えてお試しください。</p>';
      } else {
        out.innerHTML = head + '<ol class="tgq-cards">' + items.map(card).join('') + '</ol>';
      }
      out.hidden = false;
      root.setAttribute('data-tgq-state', 'result');
      if (layout !== 'b' || window.innerWidth < 990) {
        var top = out.getBoundingClientRect().top;
        if (top > window.innerHeight * 0.6 || top < 0) {
          out.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }

    root.addEventListener('click', function (event) {
      var game = event.target.closest('[data-tgq-game]');
      if (game && root.contains(game)) {
        state.game = game.getAttribute('data-tgq-game');
        root.querySelectorAll('[data-tgq-game]').forEach(function (el) {
          el.setAttribute('aria-pressed', el === game ? 'true' : 'false');
        });
        render();
        return;
      }
      var comfort = event.target.closest('[data-tgq-comfort]');
      if (comfort && root.contains(comfort)) {
        state.comfort = comfort.getAttribute('data-tgq-comfort');
        root.querySelectorAll('[data-tgq-comfort]').forEach(function (el) {
          el.setAttribute('aria-pressed', el === comfort ? 'true' : 'false');
        });
        render();
      }
    });
    root.setAttribute('data-tgq-ready', 'true');
  }

  /* tg-gss-main.js（defer）より先に読まれるため、DOMContentLoaded まで待つ */
  var booted = false;
  function boot() {
    if (booted) return;
    booted = true;
    document.querySelectorAll('[data-tgq-root]').forEach(init);
  }

  if (document.readyState === 'complete') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
    window.addEventListener('load', boot);
  }
})();
